import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import HintPopup from '../HintPopup';
import touchIcon from './icons/touch.svg';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

const useStyles = makeStyles((theme) => ({
  text: {
    marginRight: 20,
    marginLeft: 20,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9em',
    },
    width: 280,
    maxWidth: '100%',
    color: 'white',
    fontFamily: ['"Montserrat"', 'sans-serif'].join(', '),
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: '16px',
    '& *': {
      color: 'white !important',
      fontFamily: 'inherit',
    },
  },
}));

const HowToConfigureHint = () => {
  const classes = useStyles();
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    const closeWhenSthIsClicked = () => {
      document.removeEventListener('click', closeWhenSthIsClicked, true);
      setShow(false);
    };
    document.addEventListener('click', closeWhenSthIsClicked, true);
  }, []);

  const itemIdentifier = useSelector((state) => state.configurator.configuration?.item?.identifier);
  const hintText = t(`howToConfigureHint.${itemIdentifier}`, '');

  return (
    <HintPopup open={!!hintText && show} onClose={handleClose}>
      <img src={touchIcon} alt="hint icon" />
      <Typography className={classes.text} dangerouslySetInnerHTML={{ __html: hintText }} />
    </HintPopup>
  );
};

export default HowToConfigureHint;
